import React, { Component, Fragment } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";

import { makeStyles } from "@material-ui/core/styles";
// import CustomerEditModel from "./CustomerEditModel";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    create_order_vedor_side,
    razor_pay_create_order,
    razor_payment,
    edit_order_vendor_side_payment,
} from "../../../store/actions/OrderingAction/vendorOrderingAction";
import { SET_ORDER_DONATION, SET_ORDER_TIP } from "../../../store/types";
import store from "../../../store/store";
import Alert from "react-s-alert";
import {
    CLEAR_CART_DATA,
    CLEAR_CART_DATA_USER_DATA,
} from "../../../store/types";
import axios from "axios";
import { ORDER_RAZORPAY_KEY, serverApi } from "../../../config/Keys";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: "100%",
        border: "0.5px solid #9E9E9E;",
        borderRadius: "5px",
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

class RightMemoPayment extends Component {
    state = {
        tip: 0,
        tipAmount: 0,
        totalTipAmount: 0,
        donationId: 0,
        donationAmount: 0,
        totalDonationAmount: 0,
        open: false,
        openTract: false,
        total_amount: 0,
        total_charges: 0,
        onlinePayment: true,
        transactional_id: 0,
        orderId: 0,
    };

    loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    async displayRazorpay(
        total,
        userId,
        name,
        phoneNo,
        email,
        orderId,
        allOrderData,
        comment
    ) {
        const res = await this.loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }

        const onSuccess = (data, orderId) => {
            const onSuccessHandler = async (response) => {
                const formData = {
                    "order_id": this.props.data?.orderData?._id,
                    "razorpay_payment_id": response.razorpay_payment_id,
                    "refund_amount": parseFloat(total).toFixed(2),
                    "comment": this.props.data?.comment,
                    "items": this.props.data?.items,
                    "memo_type": "DEBIT",
                    "adjustment_fee": this.props.data?.adjustment,
                    "payment_type": "RAZORPAY"
                };
                const token = this.props.auth.user.accessToken;
                let initiatePayment = await axios.post(`${serverApi}/razorpay`, formData, {
                    params: { orderMemo: true, vendor: true, paymentCheck: true },
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    }
                });
                if (initiatePayment.data) {
                    Alert.success(`<h4>Debit Memo Created  Successfully</h4>`, {
                        position: "top-right",
                        effect: "bouncyflip",
                        beep: true,
                        html: true,
                        timeout: 3000,
                        offset: 35,
                    });
                    return this.props?.history.push('/memolist');
                }
            };

            const onFailure = (response) => {
                Alert.error(`<h4>Debit Memo Failure, Try Later </h4>`, {
                    position: "top-right",
                    effect: "bouncyflip",
                    beep: true,
                    html: true,
                    timeout: 3000,
                    offset: 35,
                });
                return this.props?.history.push('/memolist');
            };

            const options = {
                key: ORDER_RAZORPAY_KEY,
                currency: data.currency,
                amount: data.amount.toString(),
                order_id: data.id,
                name: "Amealio",
                description: "Amealio Ordering Payment",
                method: {
                    netbanking: false,
                    card: true,
                    wallet: false,
                    upi: false,
                },
                handler: function (response) {
                    onSuccessHandler(response);
                },
                prefill: {
                    name: name,
                    email: email,
                    contact: phoneNo,
                },
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
            paymentObject.on("payment.failed", function (response) {
                onFailure(response);
            });
        };

        const formData = {
            amount: parseFloat(total).toFixed(2),
            user_id: userId,
            refModel: "User",
            message: comment,
            currency: "INR",
            isEvent: false,
            receipt: orderId,
            orderId: orderId,
            transaction_type: "RAZORPAY",
        };

        const token = this.props.auth.user.accessToken;
        this.setState({ token: token });
        let initiatePayment = await axios.post(`${serverApi}/razorpay`, formData, {
            params: { orderMemo: true, vendor: true, paymentInitiate: true },
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
            }
        });
        if (initiatePayment.status == 201) {
            onSuccess(initiatePayment.data, orderId)
        }

    }

    setOpenTract = () => {
        this.setState({ open: false, openTract: true });
    };

    onError = (err) => {
        Alert.error(`<h4>${err ? err : "Unable to process your order"}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
        });
    };


    onSuccess = (data, orderId) => {
        if (data.payment_method === 0 || data.payment_method === 6) {
            // cash

            Alert.success(`<h4>Order Created  Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
            });
            store.dispatch({
                type: CLEAR_CART_DATA,
                //payload: formData,
            });
            store.dispatch({
                type: CLEAR_CART_DATA_USER_DATA,
                //payload: formData,
            });
            this.props.history.push("/orderdashboard");
        } else {
            this.displayRazorpay(
                data.total_amount,
                data.user_details.userId,
                data.user_details.first_name,
                data.user_details.mobile_number,
                data.user_details.email,
                orderId,
                data
            );
        }
        //this.props.history.push("/orderdashboard");
    };

    onSuccessPayment = () => {

        store.dispatch({
            type: CLEAR_CART_DATA,
            //payload: formData,
        });
        store.dispatch({
            type: CLEAR_CART_DATA_USER_DATA,
            //payload: formData,
        });
        this.props.history.push("/orderdashboard");
    };


    onClickProceed = async () => {
        let amount = this.props.data?.refund - this.props.data?.adjustment;
        if (this.props.payMethod === 0) {
            const formData = {
                "order_id": this.props.data?.orderData?._id,
                "razorpay_payment_id": null,
                "refund_amount": parseFloat(amount).toFixed(2),
                "comment": this.props.data?.comment,
                "items": this.props.data?.items,
                "memo_type": "DEBIT",
                "adjustment_fee": this.props.data?.adjustment,
                "payment_type": "RAZORPAY"
            };
            const token = this.props.auth.user.accessToken;
            let initiatePayment = await axios.post(`${serverApi}/orderMemo`, formData, {
                params: { orderMemo: true, vendor: true, paymentCheck: true },
                headers: {
                    Authorization: token,
                    "Content-Type": "application/json",
                }
            });
            if (initiatePayment.data) {
                Alert.success(`<h4>Debit Memo Created  Successfully</h4>`, {
                    position: "top-right",
                    effect: "bouncyflip",
                    beep: true,
                    html: true,
                    timeout: 3000,
                    offset: 35,
                });
                return this.props?.history.push('/memolist');
            }
         } else {
            this.displayRazorpay(
                amount,
                this.props.data?.userData?._id,
                this.props.data?.userData?.first_name,
                this.props.data?.userData?.mobile_number,
                this.props.data?.userData?.email,
                this.props.data?.orderData.order_id,
                this.props.data?.orderData?.restaurant_id,
                this.props.data?.comment
            );
        }
    };

    render() {
        const { data, payment } = this.props;
        return (
            <React.Fragment>
                <Container fluid>
                    {/* <CustomerEditModel cart={cart} payment={payment} /> */}
                    {
                        <div>
                            <h6>
                                Customer Details
                            </h6>
                            <p>{data?.orderData?.order_id || ""}</p>
                            <p>Order ID</p>
                            <hr />
                            <br />
                            <h4>
                                {`${data?.orderData?.user_details?.first_name || ''} ${data?.orderData?.user_details?.last_name || ''}`}
                            </h4>
                            <h4>
                                {`${data?.orderData?.user_details?.country_code || ''} ${data?.orderData?.user_details?.mobile_number || ''}`}
                            </h4>
                            <hr />
                            <Fragment>
                                {
                                    <Fragment>
                                        <div style={{ paddingTop: "5%" }}>
                                            <h6>Memo Total</h6>
                                            <br />
                                            <Row>
                                                <Col md={6}>Sub Total</Col>
                                                <Col md={6}>{data?.orderData?.base_amount || 0}</Col>
                                                <Col md={6}>Discount</Col>
                                                <Col md={6}>{'-'}</Col>
                                                <Col md={6}>Tips</Col>
                                                <Col md={6}>{data?.orderData?.tip?.amount || 0}</Col>
                                                <Col md={6}>Donation</Col>
                                                <Col md={6}>{data?.orderData?.donation?.amount || 0}</Col>
                                                <Col md={6}>Grand Total</Col>
                                                <Col md={6}>{data?.orderData?.total_amount || 0}</Col>
                                                <Col md={6}>Refund Totals</Col>
                                                <Col md={6}> {data?.refund || 0}</Col>
                                                <Col md={6}>Adjustment Fee</Col>
                                                <Col md={6}> {data?.adjustment || 0}</Col>
                                                <Col md={6}>Net Refund</Col>
                                                <Col md={6}>{`${data?.refund || 0}` - `${data?.adjustment || 0}`}</Col>
                                            </Row>
                                        </div>
                                        <hr />
                                        <div class="mt-3 d-flex">
                                            <button
                                                type="button"
                                                class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                                                title="Cancel Button"
                                                onClick={() =>
                                                    this.props.history.push("/memolist")
                                                }
                                            >
                                                Cancel
                      </button>
                                            <button
                                                type="button"
                                                class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                                title="Save Button"
                                                onClick={() => {
                                                    if (payment) {
                                                        this.onClickProceed();
                                                    }
                                                }}
                                            >
                                                Proceed
                      </button>
                                        </div>{" "}
                                    </Fragment>
                                }
                            </Fragment>
                            <hr />
                        </div>
                    }
                </Container>
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors.errors,
    onboarding: state.onboarding.restaurantDetails,
    cart_data: state.vendorOrdering.vendor_cart_data,
    user_data: state.vendorOrdering.vendor_order_data,
    order_id: state.vendorOrdering.order_id,
});

export default withRouter(
    connect(mapStateToProps, {
        create_order_vedor_side,
        razor_pay_create_order,
        razor_payment,
        edit_order_vendor_side_payment,
    })(RightMemoPayment)
);

